module.exports = __webpack_public_path__ + "static/media/weekly-statistics-active-icon.3f6de768.svg";